import { Component, OnInit } from '@angular/core';
import { JobService } from 'src/app/services/job.service';
import { Job } from 'src/app/models/job';
import { UtilityService } from 'src/app/services/utility.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-jobdetails',
  templateUrl: './jobdetails.component.html',
  styleUrls: ['./jobdetails.component.scss']
})
export class JobdetailsComponent implements OnInit {

  job: Job;
  jobs: any[] = [];
  jobId: number = 0;
  constructor(private utilityService: UtilityService, private jobService: JobService, private router: Router) { }

  ngOnInit(): void {
    let jobIdCheck = this.router.url.split('/').pop();
    this.jobId = jobIdCheck == undefined ? 0 : parseInt(jobIdCheck) || 0;
    this.fetchJob(true);
  }
  fetchJob(init: boolean) {
    this.jobService.getById(this.jobId)
      .pipe()
      .subscribe(
        data => {
          this.job = data;
          this.jobService.getAllByJobCategory(this.job.jobCategoryId)
            .pipe()
            .subscribe(
              data => {
                this.jobs = data;
              },
              error => {
              });
        },
        error => {
        });
  }
}
